import { IDiscipline } from "Data/interfaces/Obra/IObraData";

export const getDisciplineDisplayName = (discipline: IDiscipline): string => {
  if (discipline.Discipline?.IsCustom) {
    return discipline.CustomName || '';
  }
  return discipline.Discipline?.Name || '';
};

export const getDisciplineDisplayAcronym = (discipline: IDiscipline): string => (
  discipline.CustomAcronym || ''
);
